export default __webpack_public_path__ + "static/media/logo.162fac84.svg";